import { Button, Grid } from "@deere/fuel-react";
import { Form, Col, Row} from '@deere/ux.uxframe-react'
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import Cookies from "js-cookie";
import { DEFAULT_LANGUAGE, SCBM_STATES_CAMPAIGN } from "../../../utils/surveyLiterals";
import { getHelpDocPdfBySurveyId } from "../../../services/surveyHelpDoc.service";
import { ModalDocument } from "../../../components/modals/ModalDocument";



export default function ReviewActions({campaign, showAgreementPopupIfRequired, survey, token, isAuthMethodOkta }) {
  const history = useHistory();
  const { t } = useTranslation();
  const [helpDocUrl, setHelpDocUrl] = useState(null);
  const [showHelpDoc, setShowHelpDoc] = useState(false);

  useEffect(() => {
    const replaceHelpDocUrl = (nextUrl) => setHelpDocUrl((prev) => {
      if (prev) window.URL.revokeObjectURL(prev);
      return nextUrl;
    });

    if (!survey || !survey.id || !token) {
      replaceHelpDocUrl(null);
      return;
    }

    let cancelled = false;
    getHelpDocPdfBySurveyId(token, survey.id, Cookies.get("i18next") || DEFAULT_LANGUAGE, isAuthMethodOkta)
      .then(async (response) => {
        const url = response.status === 200 ? window.URL.createObjectURL(await response.blob()) : null;
        if (cancelled) {
          if (url) window.URL.revokeObjectURL(url);
          return;
        }
        replaceHelpDocUrl(url);
      })
      .catch((err) => {
        console.log(err);
        if (!cancelled) replaceHelpDocUrl(null);
      });

    return () => { cancelled = true; };
  }, [survey && survey.id, token, isAuthMethodOkta]);

  function disableSubmitButtons(campaign) {
    return campaign.status === SCBM_STATES_CAMPAIGN.CLOSED;
  }

  return (
    <>
    <Row className="card position-sticky fixed-bottom d-print-none">
    <Row className="card position-sticky fixed-bottom">
    <Col md="24" className="card-body p-3">
    <Form.Group as={Col} className="align-right"> 
      <Grid container justifyContent={helpDocUrl ? "space-between" : "flex-end"} className="d-print-none">
        {helpDocUrl && (
          <Button variant="secondary" type="button" onClick={() => setShowHelpDoc(true)}>
            {t("lbl_Help_Doc")}
          </Button>
        )}
        <div>
          <Button variant="secondary" className="float-right mr-2" onClick={() => history.goBack()}>
            {t("btn_review_back_to_edit")}
          </Button>
          <Button variant="primary" className="float-right mr-2" onClick={showAgreementPopupIfRequired} disabled={disableSubmitButtons(campaign)} >
            {t("btn_review_submit")}
          </Button>
        </div>
      </Grid>
      </Form.Group>
    </Col>
      </Row>
      </Row>
      <ModalDocument
        showModal={showHelpDoc}
        setShowModal={setShowHelpDoc}
        labelBtnPrimary={t("btn_close")}
        titleModal={t("lbl_Help_Doc")}
        iFrameUrl={helpDocUrl}
      />
    </>
  );
}
